import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import Car from '@serko/zui-icons/es/CarIcon';
import Fare from '@serko/zui-icons/es/FareIcon';
import Key from '@serko/zui-icons/es/KeyIcon';
import classNames from 'classnames';
import React, { FunctionComponent } from 'react';
import compose from 'recompose/compose';
import pure from 'recompose/pure';
import { SegmentTypes } from '../../../../../models/itinerary';

const getIconByType = (type: SegmentTypes) => {
  switch (type) {
    case 'Hotel':
      return Key;
    case 'Air':
      return Fare;
    case 'Car':
      return Car;
  }
};

interface OwnProps {
  type: SegmentTypes;
  className?: string;
}

interface RateIconProps extends OwnProps, WithStyles<typeof styles> {}

const RateIconBase: FunctionComponent<RateIconProps> = ({
  classes,
  className,
  type,
  ...props
}) => {
  const Icon = getIconByType(type);

  return <Icon className={classNames(className, classes.root)} {...props} />;
};

// styled
const styles = (theme: Theme) =>
  createStyles({
    root: {
      color: theme.zeno.icons.dark.active,
    },
  });

const enhance = compose<RateIconProps, OwnProps>(
  pure,
  withStyles(styles),
);

export const RateIcon = enhance(RateIconBase);

RateIcon.displayName = 'RateIcon';
